import { render, staticRenderFns } from "./component-bbf0c1bb.vue?vue&type=template&id=0d4b802f&scoped=true&"
import script from "./component-bbf0c1bb.vue?vue&type=script&lang=js&"
export * from "./component-bbf0c1bb.vue?vue&type=script&lang=js&"
import style0 from "./component-bbf0c1bb.vue?vue&type=style&index=0&id=0d4b802f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4b802f",
  null
  
)

export default component.exports